/**
 * Large variant of the box slider (acf.large_box_slider_section).
 */

import { OpsiBoxSlider } from "./OpsiBoxSlider";
import { OPSI_PART_SPACING } from "../utils/opsiHelpers";

export const OpsiLargeBoxSlider = ({ data, className = `opsi-large-box-slider ${OPSI_PART_SPACING}` }) => (
  <OpsiBoxSlider data={data} variant="large" className={`${className} overflow-hidden`} />
);
